import * as React from "react";
import { TileNavigation } from "./TileNavigation";
import { HtmlContent } from "./HtmlContent";
import { Area } from "../General/Area";
import { Link } from "../General/Link";
import { RecentFileList } from "../RecentFiles/RecentFileList";
import { Urls } from "../Urls";
import { Strings } from "../Stores/StringsStore";
import { AppStore } from "../Stores/AppStore";
import { NotificationStore } from "../Stores/NotificationStore";
import { newGuid } from "../Utilities";
import { DialogStore } from "../Stores/DialogStore";

export class Home extends React.Component<{}, {}> {

	componentWillMount() {
		if (AppStore.context.sessionDetails.isApp) {
			AppStore.isBusy = true;
			AppStore.updatePortals().then(() => {
				AppStore.isBusy = false;
				this.checkForPortal();
			}).catch((error: any) => {
				AppStore.isBusy = false;
				this.checkForPortal();
				DialogStore.showError(Strings.general.errorDialogTitle, error);
			});
		}
	}

	checkForPortal() {
		if (AppStore.portals.length == 0) {
			AppStore.keepOnPage(Urls.portals + "/" + newGuid(), true);
		}
	}

	componentDidMount() {
		AppStore.setTitle(AppStore.context.applicationTitle);
	}

	componentDidUpdate() {
		AppStore.setTitle(AppStore.context.applicationTitle);
	}

	render() {
		return <Area>
			<div className="area-start__body">

				<div className="area-start__body-half is--left-column">
					<TileNavigation />
					<div className="recent-filelist-container">
						<span>{Strings.homepage.recentFilesTitle}</span>
						{!AppStore.context.sessionDetails.isApp || AppStore.context.portalSettings.id ? <RecentFileList number={10} className="recentFileList" /> : null}
					</div>
				</div>
				<div className="area-start__body-half is--right-column">
					<div className="area-start__logo">
						<img src={Urls.applicationLogo} alt="" />
					</div>
					<HtmlContent location={{ pathname: "applicationlead" }} />
					<div className="html-content__nav">
						<Link to={Urls.imprintUrl} testId="imprintLink">{Strings.homepage.imprintTitle}</Link>
						<Link to={Urls.legalnoticeUrl} testId="legalNoticeLink">{Strings.homepage.legalNoticeTitle}</Link>
						<Link to={Urls.privacypolicyUrl} testId="privacyPolicyLink">{Strings.homepage.privacyPolicyTitle}</Link>
					</div>
				</div>
			</div>
		</Area>;
	}
}
